import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { compose } from 'redux';

import FormError from 'components/FormError';
import { getSubmitSucceeded } from 'reducers';

const ExpireSubscriptionButton = ({
  handleSubmit,
  text,
  error,
  submitSucceeded,
  newSub,
}) => (
  <form onSubmit={handleSubmit}>
    <button disabled={submitSucceeded || !newSub} className="btn btn-danger">
      {text}
    </button>
    {!newSub && (
      <div className="text-danger">
        You must create a new subscription first.
      </div>
    )}
    {error && <FormError error={error} />}
  </form>
);

const mapStateToProps = (state) => ({
  submitSucceeded: getSubmitSucceeded(state, 'expireSub'),
});

const mapDispatchToProps = (
  dispatch,
  { subId, expireSubscription, expiry_type, pin },
) => ({
  onSubmit: () => expireSubscription(subId, { expiry_type, pin }),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({ form: 'expireSub' }),
)(ExpireSubscriptionButton);
